module.exports = __webpack_public_path__ + "img/Globalization-pana.c9df1b11.png";